import { render, staticRenderFns } from "./delegacion.vue?vue&type=template&id=6f603a28&"
import script from "./delegacion.vue?vue&type=script&lang=js&"
export * from "./delegacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports